<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="`${isEditing ? 'Editar' : 'Nova'} Categoria`"
    type-modal="add_equipment_category_modal"
  >
    <div class="modal-content__main">
      <d-form @submit.prevent="save">
        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="categoryName">Nome da Categoria *</label>
            <d-form-input
              id="categoryName"
              v-model="categoryModel.name"
              type="text"
              placeholder="Digite o nome da categoria"
              :state="errors.name.required ? false : null"
            />
            <d-form-invalid-feedback v-if="errors.name.required">
              O nome da categoria é obrigatório.
            </d-form-invalid-feedback>
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
        :disabled="loading"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        {{ isEditing ? 'Atualizar' : 'Salvar' }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import EquipmentService from '_services/rest/modules/equipment';
import { CATEGORY_MODEL, _LOAD_EQUIPMENT_CATEGORY_, _RELOAD_EQUIPMENT_CATEGORY_ } from '../EquipmentModel';

export default {
  name: 'equipment-category-modal',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      categoryModel: { ...CATEGORY_MODEL },
      loading: false,
      errors: {
        name: { required: false },
      },
    };
  },
  computed: {
    isEditing() {
      return this.categoryModel.id !== null;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getEquipmentCategories',
    ]),
    cancel() {
      this.setToggle({ type: 'add_equipment_category_modal', bool: false });
    },
    resetErrors() {
      this.errors.name.required = false;
    },
    checkForm() {
      this.errors.name.required = !this.categoryModel.name || this.categoryModel.name.trim() === '';
      return !this.errors.name.required;
    },
    save() {
      if (!this.checkForm()) {
        return;
      }

      this.toggleLoading();
      EquipmentService.saveCategory(this.categoryModel)
        .then(response => {
          this.cancel();
          this.activeAlert({
            message: `Categoria ${this.isEditing ? 'atualizada' : 'criada'} com sucesso`,
            theme: 'success',
          });
          Events.$emit(_RELOAD_EQUIPMENT_CATEGORY_, response);
        })
        .catch(error => {
          this.activeAlert({
            message: error.message || 'Erro ao salvar categoria',
            theme: 'danger',
          });
        })
        .finally(() => {
          this.toggleLoading();
        });
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_EQUIPMENT_CATEGORY_, category => {
      this.categoryModel = category ? { ...category } : { ...CATEGORY_MODEL };
      this.resetErrors();
    });
  },
  beforeDestroy() {
    Events.$off(_LOAD_EQUIPMENT_CATEGORY_);
  },
};
</script>

<style lang="scss" scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>
